// extracted by mini-css-extract-plugin
export default {"banner-badge":"BannerBadge_banner-badge__Z3ci3","banner-badge__icon":"BannerBadge_banner-badge__icon__Lh0PZ","banner-badge__text":"BannerBadge_banner-badge__text__6rI6H"};